{
  "title": "Clients",
  "search": "Search",
  "completedUsersOnly": "Completed Users Only",
  "addModal": {
    "title": "Create new client",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "lastName": "Last Name",
    "email": "Email",
    "organization": "Organization",
    "type": "Relation type",
    "createAndLinkAuthProfile": "Auto create and link auth profile",
    "autoInviteUser": "Auto-invite user",
    "emailError": "Email already exists"
  },
  "table": {
    "id": "ID",
    "name": "Name",
    "email": "Email",
    "suitabilityScore": "Suitability Score",
    "completedAt": "Profile Completed",
    "organization": "Organization",
    "province": "Province",
    "dateOfBirth": "Date of Birth",
    "notCompleted": "Not Completed",
    "totalAssets": "Total Assets"
  },
  "auditTypes": {
    "UPDATE": "Update",
    "CREATE": "Create",
    "DELETE": "Delete"
  }
}
